import { message } from 'antd';
message.config({ duration: 1 });
export const MessageTip = message;
